import {
  Component, Input, HostBinding, Output, EventEmitter,
  ChangeDetectorRef, forwardRef,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';



@Component({
  moduleId: module.id,
  selector: 'slide-toggle',
  templateUrl: 'slide-toggle.component.html',
  styleUrls: ['slide-toggle.component.scss'],
  providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SlideToggleComponent),
      multi: true
  }],
})
export class SlideToggleComponent implements ControlValueAccessor {
  @HostBinding('class.reverted')
  @Input() revertStyles: boolean = false; // use it to revert styles of checked/unchecked

  @HostBinding('class.checked')
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('checked') _checked: boolean = false;

  @Input() disabled: boolean = false;

  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();

  private onChangeCallback: any = () => {};
  private onTouchedCallback: any = () => {};

  constructor(private ref: ChangeDetectorRef) {}

  get checked() {
    return this._checked;
  }

  set checked(checked: boolean) {
    this._checked = checked;
    this.onChangeCallback(checked);
    this.onTouchedCallback();
  }

  /*******************************************
  * COMPONENT PUBLIC METHODS
  *******************************************/
  // Allows Angular to update the model (checked).
  // Update the model and changes needed for the view here.
  public writeValue(value: any): void {
    this.checked = value;
  }

  // Allows Angular to register a function to call when the model (checked) changes.
  // Save the function as a property to call later here.
  public registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  public registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  // Allows Angular to disable the input.
  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public toggle() {
    this.checked = !this.checked;
  }
}
